import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
const containerVariants = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 16,
    scale: 0.97
  },
  visible: {
    opacity: 1,
    y: 0,
    scale: 1,
    transition: {
      duration: 0.5
    }
  }
};
export function PainPoints() {
  return <section className="bg-light py-20 md:py-32 px-5" data-id="element-98">
      <div className="max-w-wide mx-auto" data-id="element-99">
        <motion.div className="text-center mb-14" initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true,
        margin: '-80px'
      }} data-id="element-100">
          <div className="inline-flex items-center gap-2 text-urgency font-display font-bold text-sm uppercase tracking-wider mb-4" data-id="element-101">
            <AlertTriangleIcon className="w-5 h-5" data-id="element-102" />
            Tu familia está en riesgo financiero
          </div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-extrabold text-dark leading-tight" data-id="element-103">
            Si esto te suena familiar…
          </h2>
        </motion.div>

        <motion.div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-12 max-w-3xl mx-auto" variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-60px'
      }} data-id="element-104">
          <motion.div variants={itemVariants} className="bg-white rounded-xl shadow-md border-l-4 border-urgency p-6" data-id="element-105">
            <div className="flex items-start gap-3" data-id="element-106">
              <AlertTriangleIcon className="w-5 h-5 text-urgency flex-shrink-0 mt-0.5" data-id="element-107" />
              <p className="font-sans text-dark leading-relaxed" data-id="element-108">
                <span className="font-serif italic text-dark/50" data-id="element-109">
                  «Mami/Papi, cómpramelo.»
                </span>{' '}
                — y cada vez que cedes, el patrón se{' '}
                <strong className="text-urgency" data-id="element-110">REFUERZA</strong>.
              </p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl shadow-md border-l-4 border-urgency p-6" data-id="element-111">
            <div className="flex items-start gap-3" data-id="element-112">
              <AlertTriangleIcon className="w-5 h-5 text-urgency flex-shrink-0 mt-0.5" data-id="element-113" />
              <p className="font-sans text-dark leading-relaxed" data-id="element-114">
                $50 aquí, $30 allá. Al año:{' '}
                <strong className="text-urgency" data-id="element-115">MILES perdidos</strong> en
                gastos que se acumulan.
              </p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl shadow-md border-l-4 border-urgency p-6" data-id="element-116">
            <div className="flex items-start gap-3" data-id="element-117">
              <AlertTriangleIcon className="w-5 h-5 text-urgency flex-shrink-0 mt-0.5" data-id="element-118" />
              <p className="font-sans text-dark leading-relaxed" data-id="element-119">
                Tu hijo está aprendiendo que{' '}
                <strong className="text-urgency" data-id="element-120">TODO se compra</strong> con
                insistencia.
              </p>
            </div>
          </motion.div>

          <motion.div variants={itemVariants} className="bg-white rounded-xl shadow-md border-l-4 border-urgency p-6" data-id="element-121">
            <div className="flex items-start gap-3" data-id="element-122">
              <AlertTriangleIcon className="w-5 h-5 text-urgency flex-shrink-0 mt-0.5" data-id="element-123" />
              <p className="font-sans text-dark leading-relaxed" data-id="element-124">
                Cada día sin sistema es un día más de{' '}
                <strong className="text-urgency" data-id="element-125">malos hábitos</strong>{' '}
                financieros.
              </p>
            </div>
          </motion.div>
        </motion.div>

        {/* Ritual statement */}
        <motion.div className="max-w-2xl mx-auto text-center" initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} viewport={{
        once: true,
        margin: '-60px'
      }} data-id="element-126">
          <p className="font-sans text-dark/60 text-lg mb-2" data-id="element-127">
            El dinero no se aprende con discursos.
          </p>
          <p className="font-display text-2xl md:text-3xl font-bold text-dark" data-id="element-128">
            Se aprende con un{' '}
            <span className="text-gradient-money" data-id="element-129">SISTEMA</span>.
          </p>
        </motion.div>

        {/* Mid CTA */}
        <motion.div className="text-center mt-10" initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} viewport={{
        once: true
      }} data-id="element-130">
          <a href="#precio" className="inline-block bg-gradient-to-r from-money-dark via-money to-emerald-400 text-white font-display font-bold text-base px-8 py-3.5 rounded-xl shadow-lg hover:scale-[1.03] active:scale-[0.98] transition-transform duration-200 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-money" data-id="element-131">
            Ver el Sistema →
          </a>
        </motion.div>
      </div>
    </section>;
}